import script from "./PageDiscussions.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDiscussions.vue?vue&type=script&setup=true&lang=js"

import "./PageDiscussions.vue?vue&type=style&index=0&id=fb7d7e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb7d7e3c"]])

export default __exports__